import {
    Badge,
    Header,
    HeaderBlock,
    HeaderItemCell,
    Tooltip,
    TooltipHandler,
    Tabs,
    Tab
} from '@genestack/ui';
import React from 'react';
import {Link} from 'wouter';

import {useNavigationInfo} from '../../../hooks/use-navigation-info';
import {useJbkbSocketReadyState} from '../../../providers/jbkb-socket';
import {UserMenu} from './user-menu';

import styles from './application-header.module.css';
import {ApplicationMenu, ApplicationMenuLinkItem} from './application-menu';

export const AppHeader = () => {
    const socketReadyState = useJbkbSocketReadyState();
    const navigationInfo = useNavigationInfo();

    const navigationItems = navigationInfo.list.map((item) => (
        <ApplicationMenuLinkItem
            key={item.value}
            isActive={item.isActive}
            title={item.title}
            path={item.path}
        />
    ));

    return (
        <Header className={styles.root}>
            <ApplicationMenu navigationItems={navigationItems} />

            <HeaderBlock shrink>
                <Tabs className={styles.tabs} value={navigationInfo.activeRoute} variant="ghost">
                    {navigationInfo.list.map((item) => {
                        const illegalLinkProps = {
                            component: Link,
                            to: item.path,
                            title: item.title
                        };

                        return (
                            <Tab
                                key={item.value}
                                value={item.value}
                                className={styles.tab}
                                {...illegalLinkProps}
                            >
                                {item.label}
                            </Tab>
                        );
                    })}
                </Tabs>
            </HeaderBlock>

            <HeaderBlock shrink>
                <HeaderItemCell>
                    {socketReadyState !== 'open' && (
                        <TooltipHandler
                            tooltip={
                                <Tooltip style={{width: 'max-content'}}>
                                    Status updates can't be received at the moment
                                </Tooltip>
                            }
                        >
                            <Badge ghost disableTextTransform>
                                {socketReadyState === 'offline' ? 'offline' : 'connecting…'}
                            </Badge>
                        </TooltipHandler>
                    )}
                </HeaderItemCell>
            </HeaderBlock>
            <HeaderBlock grow />
            <UserMenu />
        </Header>
    );
};
